/* @jsx mdx */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsx mdx */
import { Noise3DSphere } from './InteractiveComponents';
export const metadata = {
  demo: Noise3DSphere,
  title: 'Noise Sphere'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`If we use a 2D noise function, we can start to create some interesting effects that are almost like hills and valleys in a terrain.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
